/**
 * Canonical saham lists untuk SPA (frontend).
 *
 * ⚠️ MUST STAY IN SYNC dengan workers authoritative source:
 * `workers/src/config/tierConfiguration.ts` (FREE_SAHAM_INSTRUMENTS + AVAILABLE_SAHAM_INSTRUMENTS)
 *
 * SPA tidak bisa import langsung dari workers/ (different runtime + build target).
 * Duplication di sini dengan sync-comment. Saat tambah saham baru:
 * 1. Update `config/tierConfiguration.ts` (workers canonical)
 * 2. Update file ini (SPA mirror)
 * 3. Verify test & build both sides
 *
 * Refactored 22 April 2026 (backlog P2 row 84) — sebelumnya hardcoded terpisah
 * di subscriptionService.ts + beberapa tempat lain = rentan drift.
 */

export const FREE_SAHAM: readonly string[] = [
  'BBRI', 'TLKM', 'GOTO', 'ANTM', 'BRIS',
] as const;

export const AVAILABLE_SAHAM: readonly string[] = [
  // Original stocks
  'ENRG', 'ALII', 'DEWA', 'BNBR', 'BUMI', 'UNSP', 'VIVA', 'MDIA',
  // Large Cap - Blue Chips
  'BBCA', 'BBRI', 'BMRI', 'TLKM', 'ASII', 'BBNI', 'AMMN', 'BREN', 'UNTR', 'ICBP',
  // Mid Cap
  'ANTM', 'ADRO', 'MDKA', 'PGAS', 'CPIN', 'INDF', 'KLBF', 'UNVR', 'MYOR',
  // Growth & Small Cap
  'GOTO', 'EMTK', 'ISAT', 'CTRA', 'BBTN', 'BRIS',
  // Blue Chip / LQ45 - Expansion
  'ARTO', 'SMGR', 'TPIA', 'BRPT', 'ESSA', 'INCO', 'PTBA', 'ITMG', 'INKP', 'TOWR',
  'MAPI', 'EXCL', 'MEDC', 'AKRA', 'PGEO', 'GGRM', 'HMSP', 'INTP', 'SRTG',
  // Mid Cap Popular
  'SMRA', 'BUKA', 'SIDO', 'ERAA', 'JPFA', 'ACES', 'PWON', 'BSDE', 'HRUM', 'TAPG',
  'MNCN', 'AGII', 'TKIM', 'PNBN',
  // Nickel / EV Chain
  'MBMA', 'NCKL',
  // Dividend & Defensive
  'BJTM', 'BJBR', 'AALI', 'SCMA',
  // Growth & Trending
  'CUAN', 'DSSA', 'BTPS', 'PTRO', 'KINO',
  // New additions
  'CNMA', 'ROTI', 'SIMP', 'LPPF', 'CDIA', 'INET', 'ZATA', 'PADI', 'WBSA',
  'HUMI', 'EMAS', 'BULL', 'BSSR', 'PANI',
  'CBDK', 'JARR', 'WIFI', 'OASA', 'NASI', 'HAIS', 'STRK', 'SMIL',
] as const;

/** Runtime check total count matches workers canonical (99 saham). */
export const SAHAM_COUNT = AVAILABLE_SAHAM.length;
